import { Component, Input } from '@angular/core';
import { CustomCarouselBanner } from 'src/app/core/model/custom-carousel-banner';

@Component({
  selector: 'app-carousel-slider',
  templateUrl: './carousel-slider.component.html',
  styleUrls: ['./carousel-slider.component.scss'],
})
export class CarouselSliderComponent {
  @Input() banners: CustomCarouselBanner[];
  @Input() videoUrl: string;
}
